<template>
  <div>
    <b-modal v-model="modalOpen" :component="getSubmissionComponent()" :events="{save: handleSubmissionUpdate}" :props="{ 'submission': currentSubmission, 'patientId': currentSubmission?.patient_id, 'patientMonitorId': currentSubmission?.patient_monitor_id, 'viewOnly': currentSubmission && !isEditable(currentSubmission) }" :can-cancel="true"></b-modal>
    <div v-if="data.length > 0" class="submissions">
      <div class="submission_item" :key="item.id" v-for="item in data" @click="viewSubmission(item)" :class="{'is-completed': item.status === 'completed'}">
        <div class="submission__header">
          <div class="submission__title">
            <img v-if="item.is_aimee" src="@/assets/aimee.png" width="15" />
            <span>{{ item.form.name }}</span>
          </div>
          <div class="submission__status">
            <span class="tag is-small" :class="getStatusClass(item)">
              {{ getStatusLabel(item) }}
            </span>
          </div>
        </div>
        <div class="submission__footer">
          <div>
            <span class="key">{{ item.form.can_update && item.status === 'completed' || !item.form.can_update ? 'Completed' : 'Filled' }} by</span>
            <span>{{ item.filled_by?.name || 'N/A' }}</span>
          </div>
          <div>
            <span class="key">@</span>
            <span>{{ $helpers.formatDate(item.updated_at) }}</span>
          </div>
        </div>
      </div>
    </div>
    <p v-else class="no-data-message">No actions were added for this patient</p>
  </div>
</template>

<script>
import FormFill from "@/components/form_builder/FormFill";

export default {
name: "FormSubmissionsList",
  props: {
    data: {
      type: Array,
      default: () => { return [] },
    },
    handleViewSubmission: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    viewSubmission(submission) {
      if (this.handleViewSubmission) {
        this.$emit('view-submission', submission)
      } else {
        this.modalOpen = true
        this.currentSubmission = submission
      }
    },
    getSubmissionComponent() {
      return FormFill
    },
    handleSubmissionUpdate() {
      this.modalOpen = false
      this.$emit('updated')
    },
    getStatusClass(item) {
      if (item.status === 'needs_review') return 'is-warning'
      if (item.status === 'completed' || !item.form.can_update) return 'is-success'
      return 'is-info'
    },
    getStatusLabel(item) {
      if (item.status === 'needs_review') return 'Needs Review'
      if (item.status === 'completed' || !item.form.can_update) return 'Completed'
      return 'Open'
    },
    isEditable(item) {
      return item?.status === 'needs_review' || (item?.status === 'in_progress' && item?.form?.can_update)
    }
  },
  data() {
    return {
      modalOpen: false,
      currentSubmission: null
    }
  }
}
</script>
<style lang="scss" scoped>
.submissions {
  display: flex;
  flex-direction: column;
}
.submission_item {
  padding: 10px 10px 10px;
  transition: all 0.1s linear;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  &:not(:last-child) {
    border-bottom: 1px solid $background-level-0;
  }
  &:hover {
    cursor: pointer;
    border-radius: 5px;
    background: $background-level-0;
  }
}
.submission__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  position: relative;
}
.submission__title {
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.key {
  color: $secondary-text-color;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  padding-right: 5px;
}
.submission__footer {
  display: flex;
  font-size: 13px;
  > div {
    padding-right: 5px;
    display: flex;
    align-items: center;
  }
}
</style>
